import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { User } from 'types';

const enableEmailMfa = async (userId: string): Promise<User> => {
  const { data } = await customAxios.post<User>(
    `/users/${userId}/mfa/email/enable`
  );
  return data;
};

export const useEnableEmailMfa = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: enableEmailMfa,
    onSuccess: (data) => {
      queryClient.setQueryData(['auth-user'], data);
    },
  });
};
